import System from 'systemjs'

const loadDependencies = (app) => {
  const dependencies = app.dependencies ? app.dependencies : [];
  dependencies.forEach(dependency => {
    System.import(dependency);
  });
};

export default loadDependencies